import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-[#DEDCCF] bg-[#F6F4EE] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-display text-3xl font-bold tracking-tight">EvalEstate</div>
            <p className="mt-3 text-sm text-[#52616B] max-w-sm leading-relaxed">
              Evaluare instantă bazată pe AI pentru proprietăți imobiliare din România.
              Date reale de piață, analize profesionale, rapoarte în 30 de secunde.
            </p>
            <div className="mt-6 mono text-[11px] uppercase tracking-[0.2em] text-[#52616B]">
              Date actualizate · Februarie 2026
            </div>
          </div>
          <div>
            <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Produs</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/evaluare" className="hover:text-[#0F6E5B] transition-colors">Evaluare instantă</Link></li>
              <li><Link to="/comparatie" className="hover:text-[#0F6E5B] transition-colors">Comparație</Link></li>
              <li><Link to="/preturi-zone" className="hover:text-[#0F6E5B] transition-colors">Hartă prețuri</Link></li>
              <li><Link to="/preturi" className="hover:text-[#0F6E5B] transition-colors">Planuri & tarife</Link></li>
              <li><Link to="/evaluare-profesionala" className="hover:text-[#0F6E5B] transition-colors">Evaluator ANEVAR</Link></li>
            </ul>
          </div>
          <div>
            <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Informații</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#metodologie" className="hover:text-[#0F6E5B] transition-colors">Metodologie</a></li>
              <li><a href="#faq" className="hover:text-[#0F6E5B] transition-colors">Întrebări frecvente</a></li>
              <li><Link to="/istoric" className="hover:text-[#0F6E5B] transition-colors">Istoric evaluări</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-[#DEDCCF] flex flex-col md:flex-row justify-between gap-3 text-xs text-[#52616B]">
          <div>© 2026 EvalEstate. Toate drepturile rezervate.</div>
          <div className="mono">Evaluările sunt estimări orientative. Pentru raport oficial, consultă un expert ANEVAR.</div>
        </div>
      </div>
    </footer>
  );
}
